'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseZonedIntervalViewModel=require('./baseZonedIntervalViewModel');let

TripViewModel=class TripViewModel extends BaseZonedIntervalViewModel{
constructor(jsonTrip){
super(jsonTrip);
this._origin=jsonTrip.origin;
this._destination=jsonTrip.destination;

if(_.exists(jsonTrip.tod)){
this._tod=jsonTrip.tod;
}

if(_.exists(jsonTrip.metadata)){
this._metadata=jsonTrip.metadata;
}
}

get origin(){
return this._origin;
}

get destination(){
return this._destination;
}

get tod(){
return this._tod;
}

get metadata(){
return this._metadata;
}};


module.exports=TripViewModel;
//# sourceMappingURL=tripViewModel.js.map
